import { CodeFieldFlagWireKey, CodeFieldWireKey, CodetableFeature, CodetableScreenName } from 'app/area/codetable/types-store';
import { CodetableListScreen, CustomCodetableListComponentProps } from 'app/area/codetable/list/list-renderer/types';
import { ConsequencesCodetableListComponent } from 'app/area/codetable/list/list-renderer/screens/consequences/consequences-codetable-list-component';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { DefaultCodetableListComponent } from 'app/area/codetable/list/list-items/default-codetable-list-component';
import { UomSetCodetableListComponent } from 'app/area/codetable/list/list-renderer/screens/uom-set/uom-set-codetable-list-component';
import { UserGroupListComponent } from 'app/area/codetable/list/list-renderer/screens/user-group/user-group-list-component';
import { UomCodetableListComponent } from 'app/area/codetable/list/list-renderer/screens/uom/uom-codetable-list-component';
import { ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { RiskMatrixAdministration } from 'app/area/risk-matrix-administration/risk-matrix-administration';
import { SeverityCodetableListComponent } from 'app/area/codetable/list/list-renderer/screens/severity/severity-codetable-list-component';

export enum SupportedListScreens {
  ConsequencesSeverity = 277,
  ConsequencesRecurrence = 278,
  ConsequencesLikelihood = 279,
  InteractionOption = 444,
  Reference = 38,
  ReferenceOption = 446,
  SubstanceHierarchy = 341,
  SubstanceCategory = 351,
  UnitOfMeasureSet = 398,
  UnitOfMeasure = 338,
  UserGroup = 19,
  RiskArea = 131,
  RiskMatrix = 132,
  RiskMatrixAdministration = 363,
  SeverityNode = 134,
  RecurrenceFrequency = 130,
  Likelihood = 169
}

export const supportedListScreens: CodetableListScreen[] = [
  {
    id: SupportedListScreens.ConsequencesSeverity,
    name: CodetableScreenName.Consequence,
    component: ConsequencesCodetableListComponent
  },
  {
    id: SupportedListScreens.ConsequencesRecurrence,
    name: CodetableScreenName.Consequence,
    component: ConsequencesCodetableListComponent
  },
  {
    id: SupportedListScreens.ConsequencesLikelihood,
    name: CodetableScreenName.Consequence,
    component: ConsequencesCodetableListComponent
  },
  {
    id: SupportedListScreens.InteractionOption,
    name: CodetableScreenName.InteractionOption,
    component: ConsequencesCodetableListComponent,
    screenProps: {
      listCategoryLabel: (translation: CodetableTranslation) => translation.interaction
    }
  },
  {
    id: SupportedListScreens.Reference,
    name: CodetableScreenName.Reference,
    component: ConsequencesCodetableListComponent,
    screenProps: {
      listCategoryLabel: (translation: CodetableTranslation) => translation.reference_type
    }
  },
  {
    id: SupportedListScreens.ReferenceOption,
    name: CodetableScreenName.ReferenceOption,
    component: DefaultCodetableListComponent,
    screenProps: {
      listCategoryLabel: (translation: CodetableTranslation) => translation.reference
    }
  },
  {
    id: SupportedListScreens.SubstanceHierarchy,
    name: CodetableScreenName.SubstanceHierarchy,
    component: DefaultCodetableListComponent
  },
  {
    id: SupportedListScreens.SubstanceCategory,
    name: CodetableScreenName.SubstanceCategory,
    component: DefaultCodetableListComponent
  },
  {
    id: SupportedListScreens.UnitOfMeasureSet,
    name: CodetableScreenName.UnitOfMeasureSet,
    component: UomSetCodetableListComponent
  },
  {
    id: SupportedListScreens.UnitOfMeasure,
    name: CodetableScreenName.UnitOfMeasure,
    component: UomCodetableListComponent
  },

  {
    id: SupportedListScreens.UserGroup,
    name: CodetableScreenName.UserGroup,
    component: UserGroupListComponent
  },
  {
    id: SupportedListScreens.RiskArea,
    name: CodetableScreenName.RiskArea,
    component: DefaultCodetableListComponent,
    screenProps: {
      limitFieldsTo: [
        CodeFieldWireKey.code,
        CodeFieldWireKey.category,
        CodeFieldWireKey.node,
        CodeFieldFlagWireKey.colour,
        CodetableFeature.parent,
        ScreenPicker.likelihood,
        ScreenPicker.recurrence,
        ScreenPicker.severity,
        ScreenPicker.sequence
      ]
    }
  },
  {
    id: SupportedListScreens.RiskMatrix,
    name: CodetableScreenName.RiskMatrix,
    component: RiskMatrixAdministration as React.ComponentClass<CustomCodetableListComponentProps>
  },
  {
    id: SupportedListScreens.SeverityNode,
    name: CodetableScreenName.SeverityNode,
    component: SeverityCodetableListComponent,
    screenProps: {
      listLevelLabel: (translation: CodetableTranslation) => translation.severity_level,
      listCategoryLabel: (translation: CodetableTranslation) => translation.severity_node,
      limitFieldsTo: [
        CodeFieldWireKey.code,
        CodeFieldFlagWireKey.level,
        CodeFieldFlagWireKey.sequence
      ]
    }
  },
  {
    id: SupportedListScreens.RecurrenceFrequency,
    name: CodetableScreenName.RecurrenceFrequency,
    component: SeverityCodetableListComponent,
    screenProps: {
      listLevelLabel: (translation: CodetableTranslation) => translation.recurrence_level,
      listCategoryLabel: (translation: CodetableTranslation) => translation.requrence_frequency,
      limitFieldsTo: [
        CodeFieldWireKey.code,
        CodeFieldFlagWireKey.level,
        CodeFieldFlagWireKey.sequence
      ]
    }
  },
  {
    id: SupportedListScreens.Likelihood,
    name: CodetableScreenName.Likelihood,
    component: SeverityCodetableListComponent,
    screenProps: {
      listLevelLabel: (translation: CodetableTranslation) => translation.likelihood_level,
      listCategoryLabel: (translation: CodetableTranslation) => translation.likelihood,
      limitFieldsTo: [
        CodeFieldWireKey.code,
        CodeFieldFlagWireKey.level,
        CodeFieldFlagWireKey.sequence
      ]
    }
  }
];
